var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIc111(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "10.8055mm",
    height: "7.3972mm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 709.61 485.78",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2464996870048"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2465009949136"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#999999",
    fillRule: "nonzero",
    x: 0.87,
    y: 114.72,
    width: 708.04,
    height: 14.59
  })), /*#__PURE__*/React.createElement("g", {
    id: "_2465009948896"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#999999",
    fillRule: "nonzero",
    x: 0.87,
    y: 354.15,
    width: 708.04,
    height: 14.59
  })), /*#__PURE__*/React.createElement("g", {
    id: "_2465009950096"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#999999",
    fillRule: "nonzero",
    x: 0.87,
    y: 235.65,
    width: 708.04,
    height: 14.59
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    transform: "matrix(0.707097 -0.707097 0.707097 0.707097 120.317 10.3183)",
    width: 14.59,
    height: 672.25
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    transform: "matrix(0.707097 -0.707097 0.707097 0.707097 120.317 475.463)",
    width: 672.25,
    height: 14.59
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2465009949376"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#999999",
    fillRule: "nonzero",
    y: 115.41,
    width: 14.59,
    height: 252.28
  })), /*#__PURE__*/React.createElement("g", {
    id: "_2465009953072"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#999999",
    fillRule: "nonzero",
    x: 695.01,
    y: 115.41,
    width: 14.59,
    height: 252.28
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc111);
export default __webpack_public_path__ + "static/media/ic_1_11.d0581bb0b23118db7c2609312a5781c4.svg";
export { ForwardRef as ReactComponent };